import DeFiPositionAssets from './DeFiPositionAssets'

export default DeFiPositionAssets
